import Icon from '@forwardflow/ui/Icons'

export const ProjectedRates = ({
   avgSpeedToAction,
   conversionRatePercent,
   responseRatePercent,
}: {
   avgSpeedToAction: {
      projected: string
      change: string
   }
   conversionRatePercent: {
      projected: number
      changeInPercent: number
   }
   responseRatePercent: {
      projected: number
      changeInPercent: number
   }
}) => {
   const hasConversionData =
      conversionRatePercent.projected !== null &&
      conversionRatePercent.projected !== 0
   const hasSpeedData =
      avgSpeedToAction.projected && avgSpeedToAction.projected !== '0'
   const hasResponseData =
      responseRatePercent.projected !== null &&
      responseRatePercent.projected !== 0

   if (!hasConversionData && !hasSpeedData && !hasResponseData) {
      return null
   }

   return (
      <div className="bg-[#594180] rounded mb-4 ">
         <div className="flex items-center justify-between px-8 py-5 border-b border-white/20">
            <span>Projected rates after Activation</span>
            <div className="flexc gap-x-2">
               <Icon name="TourIcon" />
               <span className="text-[14px] font-semibold">Activate</span>
            </div>
         </div>
         <div className="flex flex-wrap px-7">
            {hasConversionData && (
               <div className="flex-1 py-5">
                  <p className="text-white/70 text-[14px] font-medium mb-1">
                     Conversion Rate
                  </p>
                  <div className="flex items-center gap-x-2">
                     <span className="text-[24px] font-medium">
                        {conversionRatePercent.projected.toFixed(2)} %
                     </span>
                     <span className=" bg-black/20 rounded-[4px] px-3 font-medium flexc gap-2 h-7">
                        <Icon name="GreenArrow" />
                        {conversionRatePercent.changeInPercent} %
                     </span>
                  </div>
               </div>
            )}

            {hasSpeedData && (
               <div className="flex-1 py-5">
                  <p className="text-white/70 text-[14px] font-medium mb-1">
                     Speed to Lead
                  </p>
                  <div className="flex items-center gap-x-2">
                     <span className="text-[24px] font-medium">
                        {avgSpeedToAction.projected || 0}
                     </span>
                     {avgSpeedToAction.change && (
                        <span className=" bg-black/20 rounded-[4px] px-3 font-medium h-7 flexc">
                           {avgSpeedToAction.change}
                        </span>
                     )}
                  </div>
               </div>
            )}

            {hasResponseData && (
               <div className="flex-1 py-5">
                  <p className="text-white/70 text-[14px] font-medium mb-1">
                     Response rate
                  </p>
                  <div className="flex items-center gap-x-2">
                     <span className="text-[24px] font-medium">
                        {responseRatePercent.projected.toFixed(2)} %
                     </span>
                     <span className=" bg-black/20 rounded-[4px] px-3 font-medium flexc gap-2 h-7">
                        <Icon name="GreenArrow" />
                        {responseRatePercent.changeInPercent} %
                     </span>
                  </div>
               </div>
            )}
         </div>
      </div>
   )
}
